import { DBSchemaType, DBMaterialType } from "../database_types";

export function getMaterials(dbSchema: DBSchemaType | undefined): DBMaterialType[] {
    if (dbSchema === undefined) {
        return []
    }
    if (dbSchema.materials === undefined) {
        return [];
    }
    return dbSchema.materials.filter((item: DBMaterialType) => item.type === 1);
}

export function getEdges(dbSchema: DBSchemaType | undefined): DBMaterialType[] {
    if (dbSchema === undefined) {
        return []
    }
    if (dbSchema.materials === undefined) {
        return [];
    }
    return dbSchema.materials.filter((item: DBMaterialType) => item.type === 3);
}

export function getMaterial(materials: DBMaterialType[], code: string): DBMaterialType | undefined {
    if (materials === undefined)
        return undefined;
    for (const mat of materials) {
        if (code === mat.code) {
            return mat;
        }
    }
}
